import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuoteStatus = ({ status, onDownloadPDF, onPrint }) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'approved':
        return {
          icon: 'CheckCircle',
          color: 'text-success',
          bgColor: 'bg-success/10',
          borderColor: 'border-success/20',
          title: 'Devis Approuvé',
          message: 'Votre devis a été approuvé avec succès. Le professionnel a été notifié et vous contactera prochainement pour planifier les travaux.'
        };
      case 'rejected':
        return {
          icon: 'XCircle',
          color: 'text-error',
          bgColor: 'bg-error/10',
          borderColor: 'border-error/20',
          title: 'Devis Refusé',
          message: 'Vous avez refusé ce devis. Le professionnel a été notifié et pourra vous proposer une version révisée si nécessaire.'
        };
      case 'expired':
        return {
          icon: 'AlertTriangle',
          color: 'text-warning',
          bgColor: 'bg-warning/10',
          borderColor: 'border-warning/20',
          title: 'Devis Expiré',
          message: 'Ce devis a dépassé sa date de validité. Veuillez contacter le professionnel pour obtenir un nouveau devis actualisé.'
        };
      default:
        return {
          icon: 'Clock',
          color: 'text-primary',
          bgColor: 'bg-primary/10',
          borderColor: 'border-primary/20',
          title: 'En Attente de Décision',
          message: 'Ce devis est en attente de votre approbation ou refus. Veuillez examiner les détails et prendre votre décision.'
        };
    }
  };

  const config = getStatusConfig();

  return (
    <div className={`border rounded-lg p-6 mb-6 ${config?.bgColor} ${config?.borderColor}`}>
      <div className="flex items-start space-x-4">
        <div className={`flex items-center justify-center w-12 h-12 rounded-full ${config?.bgColor} border ${config?.borderColor}`}>
          <Icon name={config?.icon} size={24} className={config?.color} />
        </div>
        
        <div className="flex-1">
          <h2 className={`text-lg font-semibold mb-2 ${config?.color}`}>
            {config?.title}
          </h2>
          <p className="text-text-secondary text-sm mb-4">
            {config?.message}
          </p>
          
          {(status === 'approved' || status === 'rejected') && (
            <div className="flex flex-wrap gap-3">
              <Button
                variant="outline"
                size="sm"
                iconName="Download"
                iconPosition="left"
                onClick={onDownloadPDF}
              >
                Télécharger PDF
              </Button>
              <Button
                variant="outline"
                size="sm"
                iconName="Printer"
                iconPosition="left"
                onClick={onPrint}
              >
                Imprimer
              </Button>
            </div>
          )}
        </div>
      </div>
      {status === 'approved' && (
        <div className="mt-4 pt-4 border-t border-success/20">
          <div className="flex items-center space-x-2 text-sm text-text-secondary">
            <Icon name="Shield" size={14} />
            <span>Signature numérique enregistrée le 07/01/2025 à 10:17</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default QuoteStatus;